import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Services from "./pages/Services";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import Portfolio from "./pages/Portfolio";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App font-body bg-[#0B0B0B] text-white min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/insights" element={<Blog />} />
          <Route path="/portfolio" element={<Portfolio />} />
        </Routes>
        <Footer />
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#141414",
              border: "1px solid rgba(212,175,55,0.2)",
              color: "#fff",
              borderRadius: 0,
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
